import { addItemsToParent } from "@/multi-relation";
import {
  appendItems as orderedAppend,
  insertItems as orderedInsert,
  insertItemsBefore as orderedInsertBefore,
} from "@/ordered-relation";
import { NO_PARENT, MULTI, ORDRD, RELATION_CONFIG } from "@/structure";

// TODO czy to powinny być metody parent itema?
export function appendItems(parent, items) {
  switch (RELATION_CONFIG[parent.childRel]) {
    case ORDRD:
      return orderedAppend(parent, items);
    case MULTI:
      return addItemsToParent(parent, items);
    case NO_PARENT:
      return clearParents(items, parent.clearRelation);
  }
  return [];
}

export function appendItem(parent, item) {
  const updated = appendItems(parent, [item]);
  if (updated.length !== 1) {
    throw `Got ${updated.length} elements instead of 1: ${updated}`;
  }
  return updated[0];
}

export function insertItems(parent, items, position) {
  switch (RELATION_CONFIG[parent.childRel]) {
    case ORDRD:
      return orderedInsert(parent, items, position);
    case MULTI:
      return addItemsToParent(parent, items);
    case NO_PARENT:
      return clearParents(items, parent.clearRelation);
  }
  return [];
}

export function insertItemsBefore(sibling, parent, items) {
  console.log("insertItemsBefore", sibling, parent, items)
  switch (RELATION_CONFIG[parent.childRel]) {
    case ORDRD:
      return orderedInsertBefore(sibling, parent, items);
    case MULTI:
      return addItemsToParent(parent, items);
    case NO_PARENT:
      return clearParents(items, parent.clearRelation);
  }
  return [];
}

export function clearParents(items, relation) {
  return items.map((item) => item.clone({ [relation]: undefined }));
}
